import React from 'react'

export default function NoTransparencyWarning({
  actionLabel,
  actionAriaLabel,
  secondaryActionLabel,
  secondaryActionAriaLabel,
  disabled = false,
  error,
  onAction,
  onSecondaryAction,
}) {
  return (
    <div className="transparency-warning">
      <span>
        No transparency detected. For best DTF results, make the background transparent.
      </span>
      {actionLabel && (
        <button
          type="button"
          aria-label={actionAriaLabel}
          disabled={disabled}
          onClick={onAction}
        >
          {actionLabel}
        </button>
      )}
      {secondaryActionLabel && (
        <button
          type="button"
          aria-label={secondaryActionAriaLabel}
          disabled={disabled}
          onClick={onSecondaryAction}
        >
          {secondaryActionLabel}
        </button>
      )}
      {error && <span className="transparency-warning__error" role="alert">{error}</span>}
    </div>
  )
}
